import { render } from "./Filters.vue?vue&type=template&id=7ed87c8e"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed87c8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed87c8e', __exports__)) {
    api.reload('7ed87c8e', __exports__)
  }
  
  module.hot.accept("./Filters.vue?vue&type=template&id=7ed87c8e", () => {
    api.rerender('7ed87c8e', render)
  })

}


export default __exports__